import { render, staticRenderFns } from "./OrangevImport.vue?vue&type=template&id=66550972&scoped=true&"
import script from "./OrangevImport.vue?vue&type=script&lang=js&"
export * from "./OrangevImport.vue?vue&type=script&lang=js&"
import style0 from "./OrangevImport.vue?vue&type=style&index=0&id=66550972&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66550972",
  null
  
)

component.options.__file = "OrangevImport.vue"
export default component.exports